import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';

const AsteriskText = () => {
  const [t] = useTranslation('ksaApplication');

  return (
    <Typography.Paragraph className="DeclarationInputs-Asterisk">
      <p>
        {t(
          '*Sanctioned countries – Iran, Syria, Cuba, North Korea, Myanmar (Burma), Crimea (Ukraine) and any other countries/territories as updated time to time by the relevant authorities.'
        )}
      </p>
    </Typography.Paragraph>
  );
};

export default AsteriskText;
